import React from 'react'
import './style.scss'
import HeroImageCard from './HeroImageCard'
import GlassEffect from '../GlassEffect/GlassEffect'

import { useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomTitle from '../../../../../components/UI/title/CustomTitle';

gsap.registerPlugin(ScrollTrigger);

export default function HeroSection({ handleClick, isVisible }) {

    useEffect(() => {
        if (isVisible) {
            gsap.to(".landing-hero-top", {
                opacity: 0,
                y: 400,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "center top",
                    scrub: true,
                    // markers: true
                },
            });
            gsap.to(".landing-hero-images-card:nth-child(4n+1)", {
                y: 150,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "bottom+=120rem top",
                    scrub: true,

                },
            });
            gsap.to(".landing-hero-images-card:nth-child(4n+2)", {
                y: 280,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "bottom+=120rem top",
                    scrub: true,

                },
            });
            gsap.to(".landing-hero-images-card:nth-child(4n+4)", {
                y: 300,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "bottom+=120rem top",
                    scrub: true,
                    // markers: true
                },
            });
        } else {
            gsap.to(".landing-hero-top", {
                opacity: 0,
                y: 200,
                ease: "none",
                scrollTrigger: {
                    trigger: "",
                    start: "top top",
                    end: "center top",
                    scrub: true,
                    // markers: true
                },
            });

            gsap.to(".landing-hero-images-card:nth-child(3n+1)", {
                y: 160,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "bottom+=120rem top",
                    scrub: true,

                },
            });
            gsap.to(".landing-hero-images-card:nth-child(3n+2)", {
                y: 70,
                ease: "none",
                scrollTrigger: {
                    trigger: ".landing-hero",
                    start: "top top",
                    end: "bottom+=120rem top",
                    scrub: true,

                },
            });
        }
    }, [isVisible]);

    return (
        <div className="landing-hero" data-theme="dark">
            <div className="landing-hero-top">
                <div className="landing-container">
                    <CustomTitle title={'The smarter way to create content with AI'} />
                    <p>Generate videos, photos, and ads with top AI models that help your brand grow</p>
                    <div className="landing-hero-top__btn-wrapper" onClick={() => handleClick('button_1')}>
                        <button className="landing-hero-top__btn" type="button">Start creating for free
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.9416 0C12.9913 2.84498e-05 13.0394 0.0186292 13.0765 0.0517367C13.1136 0.0849463 13.1371 0.131137 13.1426 0.180654C13.2294 0.950311 13.4642 1.51663 13.8483 1.90832L14.0001 2.04742C14.3736 2.35511 14.8837 2.54654 15.5641 2.60719C15.6146 2.61164 15.6622 2.63508 15.6964 2.6725C15.7304 2.70982 15.749 2.75855 15.749 2.80905C15.7489 2.85976 15.7298 2.90911 15.6955 2.94645C15.6613 2.98358 15.6144 3.00654 15.5641 3.01091C14.7994 3.07653 14.2317 3.31621 13.8406 3.70808C13.4485 4.09965 13.2091 4.66621 13.1426 5.43065C13.1376 5.48064 13.1146 5.52756 13.0773 5.56127C13.0401 5.59495 12.991 5.61301 12.9408 5.61301C12.8907 5.61291 12.8422 5.59483 12.8051 5.56127C12.7772 5.53607 12.757 5.50353 12.7465 5.46797L12.7398 5.43065C12.6703 4.65361 12.43 4.0987 12.0409 3.71571L11.8857 3.57916C11.5588 3.31904 11.1318 3.1423 10.5923 3.04907L10.3132 3.01006C10.2643 3.00401 10.2196 2.97989 10.1868 2.94305C10.1541 2.90607 10.1352 2.85847 10.1351 2.80905C10.135 2.75972 10.1534 2.71209 10.186 2.67504C10.2184 2.63832 10.263 2.61359 10.3115 2.60719L10.3124 2.60804C11.0948 2.51767 11.6499 2.28297 12.0324 1.90069C12.4149 1.51821 12.6494 0.962555 12.7398 0.180654C12.7453 0.131137 12.7696 0.0849463 12.8068 0.0517367C12.8439 0.0186756 12.8919 0 12.9416 0Z" fill="white" />
                                <path d="M7.15153 1.44844C7.30068 1.44842 7.44497 1.50131 7.55949 1.59686C7.67402 1.69242 7.75161 1.82499 7.77831 1.97174C8.12745 3.89195 8.72224 5.19882 9.63744 6.11407C10.5519 7.02855 11.8596 7.62319 13.7789 7.97235C13.9256 7.99899 14.0591 8.07673 14.1546 8.19117C14.2502 8.30564 14.303 8.44999 14.3031 8.59913C14.3031 8.74836 14.2503 8.89339 14.1546 9.00793C14.0591 9.12226 13.9264 9.19926 13.7798 9.2259C11.8597 9.57505 10.5527 10.1707 9.63744 11.0859C8.72288 12.0004 8.12746 13.3078 7.77831 15.2274C7.7517 15.3742 7.674 15.5066 7.55949 15.6022C7.44496 15.6979 7.30075 15.7507 7.15153 15.7507C7.00231 15.7507 6.85811 15.6979 6.74358 15.6022C6.62907 15.5066 6.55137 15.3742 6.52476 15.2274C6.17563 13.3072 5.58079 12.0003 4.66563 11.085C3.75112 10.1705 2.44357 9.57505 0.524152 9.2259C0.377373 9.19933 0.244078 9.12238 0.148425 9.00793C0.0527619 8.89339 0 8.74836 0 8.59913C6.61911e-05 8.45 0.0528269 8.30564 0.148425 8.19117C0.244088 8.07663 0.377306 7.99894 0.524152 7.97235C2.44426 7.62319 3.75127 7.02843 4.66648 6.11322C5.58091 5.19869 6.17563 3.89113 6.52476 1.97174C6.55146 1.825 6.62906 1.69242 6.74358 1.59686C6.8581 1.50131 7.00239 1.44842 7.15153 1.44844ZM7.07096 4.7053C6.69615 5.60757 6.2057 6.37474 5.56636 7.0148C4.92637 7.65397 4.15982 8.14466 3.25771 8.5194L3.06434 8.59913L3.25771 8.6797C4.15989 9.05447 4.92634 9.54506 5.56636 10.1843L5.7996 10.4303C6.32682 11.018 6.74304 11.7036 7.07096 12.4929L7.15153 12.6863L7.23211 12.4929C7.6069 11.5908 8.09745 10.8243 8.73671 10.1843L8.98267 9.95191C9.57053 9.42456 10.2559 9.00766 11.0454 8.6797L11.2387 8.59913L11.0454 8.5194C10.1432 8.14465 9.37671 7.65399 8.73671 7.0148C8.09737 6.37474 7.60692 5.60757 7.23211 4.7053L7.15153 4.51278L7.07096 4.7053Z" fill="white" />
                            </svg></button>
                        <div className="landing-hero-top__btn-blick">
                            <span>

                                {isVisible ? <svg width="49" height="112" viewBox="0 0 49 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_f_1497_11819)">
                                        <rect width="8.52936" height="100.259" transform="matrix(0.710742 0.703452 -0.319173 0.947697 37 5)" fill="white" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_f_1497_11819" x="0" y="0" width="48.0625" height="111.016" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                            <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_1497_11819" />
                                        </filter>
                                    </defs>
                                </svg>
                                    : <svg width="49" height="69" viewBox="0 0 49 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_f_1497_11817)">
                                            <rect x="37" y="5" width="7" height="64" transform="rotate(30 37 5)" fill="white" />
                                        </g>
                                        <defs>
                                            <filter id="filter0_f_1497_11817" x="0" y="0" width="48.0625" height="68.9258" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                                <feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_1497_11817" />
                                            </filter>
                                        </defs>
                                    </svg>}
                            </span>
                        </div>
                        <div className="landing-hero-top__btn-bg">


                            <img src={`${process.env.REACT_APP_BASENAME}/img/Border.svg`} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            {isVisible ? <div className="landing-hero-images">
                <HeroImageCard img={'landing/h9.webp'} icon={'landing/hi9.svg'} />
                <HeroImageCard img={'landing/h1.webp'} icon={'landing/hi1.svg'} />
                <HeroImageCard img={'landing/h2.webp'} icon={'landing/hi2.svg'} />
                <HeroImageCard img={'landing/h6.webp'} icon={'landing/hi6.svg'} />
                <HeroImageCard img={'landing/h10.webp'} icon={'landing/hi10.svg'} />
                <HeroImageCard img={'landing/h4.webp'} icon={'landing/hi4.svg'} video={'h4.mp4'} aspectRatio={'760/554'} />
                <HeroImageCard img={'landing/h5.webp'} icon={'landing/hi5.svg'} video={'h5.mp4'} aspectRatio={'760/554'} />
                <HeroImageCard img={'landing/h3.webp'} icon={'landing/hi3.svg'} />
                <div ></div>
                <div ></div>
                <HeroImageCard img={'landing/h7.webp'} icon={'landing/hi7.svg'} />
                <HeroImageCard img={'landing/h8.webp'} icon={'landing/hi8.svg'} />
            </div> : <div className="landing-hero-images">
                <HeroImageCard img={'landing/h1.webp'} icon={'landing/hi1.svg'} />
                <HeroImageCard img={'landing/h2.webp'} icon={'landing/hi2.svg'} />
                <HeroImageCard img={'landing/h3.webp'} icon={'landing/hi3.svg'} />
                <HeroImageCard img={'landing/h4.webp'} icon={'landing/hi4.svg'} video={'h4.mp4'} aspectRatio={'760/554'} />
                <HeroImageCard img={'landing/h5.webp'} icon={'landing/hi5.svg'} video={'h5.mp4'} aspectRatio={'760/554'} />
                <HeroImageCard img={'landing/h6.webp'} icon={'landing/hi6.svg'} />
                <div ></div>
                <HeroImageCard img={'landing/h7.webp'} icon={'landing/hi7.svg'} />
                <HeroImageCard img={'landing/h8.webp'} icon={'landing/hi8.svg'} />
            </div>}

        </div>
    )
}
